require('./mmenu')

// Header
let searchField = document.getElementById('js-header__search--field'),
    openSearch = document.getElementById('quickAccess__search');
const root = document.querySelectorAll('html')[0];

window.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('js-search-open')) {
        toggleSearchField();
    }
});

openSearch.addEventListener('click', function () {
    toggleSearchField();
});

const toggleSearchField = () => {
    root.classList.toggle('js-search-open');

    if (!root.classList.contains('js-search-open')) {
        searchField.value = "";
    } else {
        searchField.focus();
        event.preventDefault();
    }
};